// 請求書 請求
$(() => {
    // 任意提出日の制御
    $('#indicate_date_check').on('change', () => {
        if ($("#indicate_date_check").prop("checked") === true) {
            $("#indicate_date").show();
        }else{
            $("#indicate_date").hide();
        }
    });

    // 備考コピー
    $(document).on("click", '.js-copy-memo', function() {
        let memo = $(this).data('memo');
        $('.js-memo').val(memo);
    });

    $('#apply-report').click(function(){
        $('.apply-report-exec').append('<input type="hidden" name="application" form="applyReport">');
    });

    $('#common_modal').on('hidden.bs.modal', function (e) {
        $('input[name="application"]').remove();
    });

    $('.apply-report-exec').click(function(){
        console.log('click applyReport');
        $('#applyReport').submit();
    });

    preventUnloadPtnInvoice();
});

// ページアンロード時の制御
function preventUnloadPtnInvoice() {
    if ($('.js-before-unload-ptn-invoice').length > 0) {
        // ブラウザバック、タブ閉じなどの時にsubmit以外のボタンによる画面遷移でモーダルを出す(ブラウザ標準)
        window.addEventListener('beforeunload', (e) => {
            let message = null;
            if (!window.js_form_submit) {
                e.preventDefault();
                e.returnValue = message;
            }
            return message;
        });
    }
}